import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { text, secondary } = theme.palette;

  return {
    tabFilters: {
      display: "flex",
      flexShrink: 1,
      justifyContent: "space-between",
      alignItems: "center",
      gap: 32,
      minHeight: 42,
      padding: "0 24px 0 0",
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        alignSelf: "end",
        padding: "0 16px 0 0"
      },
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        padding: "0 16px"
      }
    },
    tabInfo: {
      fontSize: 12,
      color: text.secondary,
      textAlign: "end",
      fontStyle: "italic"
    },
    checkbox: {
      padding: 0,
      paddingLeft: 16,
      "& .MuiSvgIcon-root": {
        width: 26,
        height: 26
      },
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        paddingLeft: 6
      }
    },
    secondaryColor: {
      color: "#797979",
      "&$checked": {
        color: secondary.dark
      }
    },
    checked: {}
  };
});
